module.exports = __webpack_public_path__ + "img/image38.4c152172.jpg";